function clockRemaining(clock, sampledAt, receivedAt, now = Date.now()) {
  if (!clock || !Number.isFinite(clock.remainingMs)) return null;
  const elapsed = clock.running ? Math.max(0, now - (receivedAt ?? sampledAt ?? now)) : 0;
  return Math.max(0, clock.remainingMs - elapsed);
}
function clockText(ms) {
  if (ms == null) return '—';
  const seconds = Math.ceil(Math.max(0, ms) / 1000);
  const h = Math.floor(seconds / 3600), m = Math.floor(seconds % 3600 / 60), s = seconds % 60;
  return h ? `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}` : `${m}:${String(s).padStart(2, '0')}`;
}
module.exports = { clockRemaining, clockText };
